import { render, staticRenderFns } from "./arena-chips.vue?vue&type=template&id=5b09250e&scoped=true"
import script from "./arena-chips.vue?vue&type=script&lang=js"
export * from "./arena-chips.vue?vue&type=script&lang=js"
import style0 from "./arena-chips.vue?vue&type=style&index=0&id=5b09250e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09250e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b09250e')) {
      api.createRecord('5b09250e', component.options)
    } else {
      api.reload('5b09250e', component.options)
    }
    module.hot.accept("./arena-chips.vue?vue&type=template&id=5b09250e&scoped=true", function () {
      api.rerender('5b09250e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/arena-chips.vue"
export default component.exports